const npsdetails = (state = [], action) => {
  switch (action.type) {
    case "NPS_DETAILS":
      return [...state, action.nps_details];
    case "CLEAR_NPS_DETAILS":
      return state.filter(
        (atd) =>
          parseInt(atd.numero_cliente) !== parseInt(action.numero_cliente)
      );
    case "EDIT_NPS_DETAILS":
      return state.map((atd) =>
        parseInt(atd.numero_cliente) === parseInt(action.numero_cliente)
          ? { ...atd, nota_nps: action.nota_nps }
          : atd
      );
    case "EDIT_CALL_CENTER_CSAT":
      return state.map((atd) =>
        parseInt(atd.numero_cliente) === parseInt(action.numero_cliente)
          ? {
              ...atd,
              conceito: action.conceito,
              nota_csat: action.nota_csat,
              cor_conceito: action.cor_conceito,
            }
          : atd
      );
    default:
      return state;
  }
};

export default npsdetails;
